import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "customFilter",
  pure: false
})
export class CustomFilterPipe implements PipeTransform {
  transform(items: any[], filter: any): any {
    if (!items || !filter) {
      return items;
    }
    return items.filter(
      item => item[filter.prop].toString().indexOf(filter.value) !== -1
    );
  }
}
